import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // form
  serviceId: null,
  serviceContentId: null,
  targetId: Constants.RegisterHash,

  // model
  // 重複して登録させないようにチェック用
  model: [],

  // input
  values: {},

  // データ更新の判別フラグ
  updated: false
}

const getters = {
	get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
}

const actions = {
	show ({commit, getters}, {serviceId, serviceContentsId, targetId, data}) {
    commit('reset')

    commit('setServiceId', serviceId)
    commit('setServiceContentId', serviceContentsId)
    commit('setTargetId', targetId)

    // data
    commit('setModel', data)

    // 編集の場合、valueに初期値を入れる
    if (getters.isModify) {
      try {
        const values = state.model.filter(item => item.keyCode === state.targetId)[0]
        commit('setValues', values)
      /* eslint-disable no-new */
      } catch (e) {
        console.log(e)
      }
    }

		// cover
		this.dispatch('core/showModalCover')
		
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
  },

  /**
   * データ更新判別フラグの切替
   */
  setUpdated ({commit}, flag) {
    commit('setUpdated', flag)
  },
  
  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  // form
  setServiceId (state, serviceId) {
    state.serviceId = serviceId
  },
  setServiceContentId (state, serviceContentsId) {
    state.serviceContentsId = serviceContentsId
  },
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setModel (state, values) {
    Vue.set(state, 'model', values)
  },
  setUpdated (state, flag) {
    state.updated = flag
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
